module.exports = __webpack_public_path__ + "img/loginFood.bea78f40.png";